import { BrandMark } from "../components/BrandMark";
import { resolveGuardWebSignInUrl } from "./guard-web-url";

/** Shown when an authenticated user has guard-only memberships. */
export function ConsoleAccessBlocked({ onSignOut }: { onSignOut: () => void }) {
  const guardUrl = resolveGuardWebSignInUrl();
  return (
    <div className="boot">
      <main className="boot__card" role="main" aria-labelledby="console-blocked-title">
        <BrandMark className="boot__mark" />
        <h1 id="console-blocked-title" className="boot__title">
          SecOps Command Center
        </h1>
        <p className="boot__tagline">Supervisor console only</p>
        <p className="boot__reason">
          This sign-in is for supervisors and account admins. Guards use the SecOps Guard app for
          patrols, checkpoints, and timeclock.
        </p>
        <div className="signin__links">
          <a href={guardUrl} className="signin__guardlink">
            Open Guard Web
          </a>
        </div>
        <button className="signin__submit" type="button" onClick={onSignOut}>
          Sign out
        </button>
      </main>
    </div>
  );
}
